var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cross-rect",
    x: 12.728,
    y: -0.0000038147,
    width: 3,
    height: 18,
    transform: "rotate(45 12.728 -3.8147e-06)",
    fill: "#828FA3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cross-rect",
    y: 2.1213,
    width: 3,
    height: 18,
    transform: "rotate(-45 0 2.1213)",
    fill: "#828FA3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon-cross.e818a5ac4e729838430d5104923eaa24.svg";
export { ForwardRef as ReactComponent };